var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-top"},[_c('div',{staticClass:"p-x-20 p-y-16 w-100 d-flex align-items-center",attrs:{"id":_vm.id}},[_c('SOInputOnOff',{attrs:{"checkboxes":_vm.paketKedaluarsa,"checked":_vm.filterItem.paketKedaluarsa},on:{"selected":_vm.selected}})],1),_c('div',{staticClass:"separator"})])
}
var staticRenderFns = []

export { render, staticRenderFns }